<template>
  <browse-filter>
    <browse-filter-checkbox
      :label="attribute.name"
      :value="attribute.slug"
      :checked="value"
      @click="select"
    >
      <em v-if="attribute.doc_count">
        ({{ attribute.doc_count }})
      </em>
    </browse-filter-checkbox>
  </browse-filter>
</template>
<script>
import BrowseFilter from './BrowseFilter.vue';
import BrowseFilterCheckbox from './BrowseFilterCheckbox.vue';

export default {
  components: {
    BrowseFilter,
    BrowseFilterCheckbox,
  },
  props: {
    value: {
      type: Boolean,
      required: false,
      default: false,
    },
    attribute: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  methods: {
    select(event) {
      this.$emit('input', event.target.checked ? true : undefined);
    },
  },
};
</script>
<style scoped>
em {
  font-style: normal;
  font-size: 12px;
  color: #8e9baa;
}
</style>
